import { useParams } from 'react-router-dom';

function RedirectToNextOpportunity() {
  const { slug } = useParams() as { slug: string };
  window.location.replace(`${process.env.REACT_APP_NEXT_URL}/opportunity-detail/${slug}`);
  return null;
}

export default RedirectToNextOpportunity;
